import { FunctionComponent, useId, useState } from "react";
import { AriaMenuStatus, HtmlNotice, informationNotice, MenuAriaModel, Select, TextOption } from "@pjs/core-ui";
import { useFactoryRef, useOnValueChange } from "@pjs/react-utilities";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { getDaysDataSet } from "../functions/GetDaysDataSet";
import { ISelectDurationStepProps } from "../interfaces/ISelectDurationStepProps";
import "../styles/select-duration-step.css";

export const SelectDurationStep: FunctionComponent<ISelectDurationStepProps> = (props) => {
    const selectId = useId();
    let noticeContent: string = "";
    let noticeAriaLabel: string = "";

    if (props.setDuration !== null) {
        const numDays = userUiI18n.getPluralString("temporary_access.steps.select_days.days", {
            count: props.setDuration,
            numDays: props.setDuration.toString()
        });

        noticeContent = userUiI18n.getString("temporary_access.steps.select_days.set_by_admin", {
            numDays: numDays
        });

        noticeAriaLabel = userUiI18n.getString("temporary_access.steps.select_days.a11y.set_by_admin", {
            numDays: numDays
        });
    }

    const [selectModel, setSelectModel] = useState<MenuAriaModel>({
        isOpen: false,
        type: AriaMenuStatus.Closed,
        activeItemIndex: 0
    });

    const methodDataSet = useFactoryRef(getDaysDataSet, props.maxDuration);

    useOnValueChange(() => {
        props.onDurationChange(methodDataSet[selectModel.activeItemIndex].numberOfDays);
    }, [selectModel.activeItemIndex]);

    return (
        <div className="uui-temporary-access__step-container">
            <h3 id={selectId} className="uui-temporary-access__title">
                {userUiI18n.getString("temporary_access.steps.select_days.title", { stepNumber: "3" })}
            </h3>
            <p className="uui-temporary-access__description">{userUiI18n.getString("temporary_access.steps.select_days.description")}</p>
            {props.setDuration === null && (
                <div className="uui-select-duration-step__select-container">
                    <Select
                        dataHook="duration-selector"
                        model={selectModel}
                        onModelChange={(model) => setSelectModel(model)}
                        dataSet={methodDataSet}
                        labelId={selectId}
                        renderOption={TextOption}
                        required={true}
                    />
                </div>
            )}
            {props.setDuration !== null && <HtmlNotice ariaLabel={noticeAriaLabel} type={informationNotice} content={noticeContent} />}
        </div>
    );
};
